module.exports = __webpack_public_path__ + "static/custom-f9357ab604e2ec201fc82ccd1443862c.png";